export const PREMIUM_COST = 10;
export const PREMIUM_THEME_COST = 1;
export const VIDEO_COST = 25;

export const MODEL_COSTS: { [key: string]: number } = {
    Anime: 1,
    Artistic: 1,
    Cheyenne: 1,
    Default: 1,
    "Dream Diffusion Lightning": 2,
    "Dreamshaper Lightning": 1,
    "Dream Tech XL": 2,
    "Envy Starlight XL": 1,
    "Flux.Pro": 8,
    "Flux.Schnell": 1,
    "Juggernaut XII": 3,
    "Juggernaut XL": 1,
    RealVisXL: 2,
    Niji: 1,
    SDXL: 1,
    "SD 3": 5,
    "Zavy Chroma XL": 1,
};

export const SIZE_COSTS: { [key: string]: number } = {
    "1024x1024": 1,
    "896x1152": 1,
    "832x1216": 1,
    "768x1344": 1,
    "640x1536": 1,
    "1536x640": 1,
    "1344x768": 1,
    "1216x832": 1,
    "1152x896": 1,
    "1024x1792": 2, // Premium size
    "1792x1024": 2, // Premium size
};

export const calculateModelCost = (model: string | null | undefined) =>
    model ? MODEL_COSTS[model] || 0 : 0;

export const calculatePremiumCost = (premium: boolean) =>
    premium ? PREMIUM_COST : 0;

export const calculateSizeCost = (size: string | null, premium: boolean) => {
    if (premium) {
        if (size === "1024x1792" || size === "1792x1024") {
            return SIZE_COSTS[size] || 1;
        }
        return SIZE_COSTS["1024x1024"] || 1;
    } else {
        if (size !== null) {
            return SIZE_COSTS[size] || 1;
        }
        return 1;
    }
};

export const calculatePremiumThemeCost = (
    premium: boolean,
    premiumTheme: boolean
) => (premiumTheme && !premium ? PREMIUM_THEME_COST : 0);

export const calculateVideoCost = (video: boolean) => (video ? VIDEO_COST : 0);

export const calculateNumStepsCost = (numSteps: number) =>
    numSteps > 0 ? Math.ceil((numSteps / 10) * 0.5) : 0;

export const calculateTotalGoldCost = (
    model: string | null,
    premium: boolean,
    aspectRatio: string | null,
    premiumTheme: boolean,
    numSteps: number,
    numImages: number
) => {
    let totalGoldCost = 0;

    totalGoldCost += calculatePremiumCost(premium);
    totalGoldCost *= calculateSizeCost(aspectRatio, premium);
    totalGoldCost += calculatePremiumThemeCost(premium, premiumTheme);
    totalGoldCost += !premium ? calculateModelCost(model) : 0;
    totalGoldCost += !premium ? calculateNumStepsCost(numSteps) : 0;
    totalGoldCost *= numImages > 0 ? numImages : 1;

    return totalGoldCost;
};
